import type { TranslationsState } from '../../common/types/index.tsx';

type TranslationPanel = {
	id: string;
	isFlagged: boolean;
	displayName: string;
};

type TranslationGroupWithPanels = {
	name: string;
	key: string;
	panels: TranslationPanel[];
};

export const getTranslationGroups = (state: TranslationsState) => {
	const { translationTabsWithPanelIds, translationPanelMap } = state;

	if (translationPanelMap == null) {
		return [];
	}

	const translationGroups = translationTabsWithPanelIds
		.filter((group) => group.translationPanelIds.length > 0)
		.map<TranslationGroupWithPanels>(({ name, key, translationPanelIds }) => {
			const panels = translationPanelIds.map((panelId) => translationPanelMap[panelId]);

			return {
				name,
				key,
				panels,
			};
		});

	return translationGroups;
};
